(function () {
  "use strict";

  var COPPER_RHO = 0.0179;

  /*
   * Planning current-density floor.
   *
   * This is NOT a certified marine ampacity table.
   * Final conductor ampacity must be checked against
   * the applicable standard and installation conditions.
   */
  var PLANNING_AMPS_PER_MM2 = 4;

  var METRIC_CABLE_SIZES = [
    1.5,
    2.5,
    4,
    6,
    10,
    16,
    25,
    35,
    50,
    70,
    95,
    120,
    150,
    185,
    240
  ];

  var AWG_MAP = {
    "18 AWG": 0.823,
    "16 AWG": 1.309,
    "14 AWG": 2.081,
    "12 AWG": 3.309,
    "10 AWG": 5.261,
    "8 AWG": 8.366,
    "6 AWG": 13.302,
    "5 AWG": 16.773,
    "4 AWG": 21.151,
    "3 AWG": 26.671,
    "2 AWG": 33.631,
    "1 AWG": 42.408,
    "1/0 AWG": 53.475,
    "2/0 AWG": 67.431,
    "3/0 AWG": 85.029,
    "4/0 AWG": 107.219,
    "250 kcmil": 126.677,
    "300 kcmil": 152.012,
    "350 kcmil": 177.348,
    "400 kcmil": 202.683,
    "500 kcmil": 253.354
  };

  var BREAKER_SIZES = [
    5, 10, 15, 20, 25, 30, 40, 50,
    60, 70, 80, 100, 120, 125, 150,
    175, 200, 225, 250, 300, 350,
    400, 500, 600
  ];

  var SWITCH_SIZES = [
    100, 150, 200, 275, 300, 350,
    400, 500, 600, 1000
  ];

  var BUSBAR_SIZES = [
    100, 150, 200, 250, 300,
    400, 500, 600, 1000
  ];

  var SHUNT_SIZES = [
    100, 200, 300, 500, 1000
  ];


  function initCalculator(root) {

    if (
      !root ||
      root.getAttribute("data-battery-initialized") === "true"
    ) {
      return;
    }


    var battVoltage =
      root.querySelector("#battVoltage");

    var battAh =
      root.querySelector("#battAh");

    var cRate =
      root.querySelector("#cRate");

    var seriesCount =
      root.querySelector("#seriesCount");

    var parallelCount =
      root.querySelector("#parallelCount");

    var mainCableLength =
      root.querySelector("#mainCableLength");

    var jumperLength =
      root.querySelector("#jumperLength");

    var voltageDrop =
      root.querySelector("#voltageDrop");


    if (
      !battVoltage ||
      !battAh ||
      !cRate ||
      !seriesCount ||
      !parallelCount ||
      !mainCableLength ||
      !jumperLength ||
      !voltageDrop
    ) {
      return;
    }


    root.setAttribute(
      "data-battery-initialized",
      "true"
    );


    function t(attribute, fallback) {

      var value =
        root.getAttribute(attribute);

      return value || fallback;

    }


    function numberValue(input, fallback) {

      var value =
        parseFloat(input.value);

      if (
        !isFinite(value) ||
        value <= 0
      ) {
        return fallback;
      }

      return value;

    }


    function integerValue(input, fallback) {

      var value =
        parseInt(input.value, 10);

      if (
        !isFinite(value) ||
        value < 1
      ) {
        return fallback;
      }

      return value;

    }


    function formatNumber(value, decimals) {

      var language =
        document.documentElement.lang ||
        "en";

      return new Intl.NumberFormat(
        language,
        {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals
        }
      ).format(value);

    }


    function setText(id, value) {

      var element =
        root.querySelector("#" + id);

      if (element) {
        element.textContent = value;
      }

    }


    function nextStandardSize(value, sizes) {

      for (
        var i = 0;
        i < sizes.length;
        i++
      ) {

        if (sizes[i] >= value) {
          return sizes[i];
        }

      }

      return null;

    }


    function closestAwg(mm2) {

      var closestLabel = "";
      var closestDifference = Infinity;

      Object.keys(AWG_MAP).forEach(
        function (label) {

          var difference =
            Math.abs(
              AWG_MAP[label] - mm2
            );

          if (
            difference <
            closestDifference
          ) {

            closestDifference =
              difference;

            closestLabel =
              label;

          }

        }
      );

      return closestLabel;

    }


    function calculateCable(
      current,
      systemVoltage,
      physicalLength,
      conductorsInCircuit,
      dropPercent
    ) {

      if (
        current <= 0 ||
        systemVoltage <= 0 ||
        physicalLength <= 0
      ) {
        return null;
      }


      var circuitLength =
        physicalLength *
        conductorsInCircuit;


      var allowedVoltageDrop =
        systemVoltage *
        (
          dropPercent /
          100
        );


      var voltageDropSection =
        (
          COPPER_RHO *
          circuitLength *
          current
        ) /
        allowedVoltageDrop;


      var currentFloorSection =
        current /
        PLANNING_AMPS_PER_MM2;


      var calculatedSection =
        Math.max(
          voltageDropSection,
          currentFloorSection
        );


      var standardSize =
        nextStandardSize(
          calculatedSection,
          METRIC_CABLE_SIZES
        );


      return {
        calculated: calculatedSection,
        voltageDropSection: voltageDropSection,
        currentFloorSection: currentFloorSection,
        size: standardSize,
        awg:
          standardSize !== null
            ? closestAwg(standardSize)
            : null
      };

    }


    function cableDisplay(result) {

      if (
        !result ||
        result.size === null
      ) {

        return {
          metric:
            t(
              "data-t-engineering-required",
              "Engineering required"
            ),

          awg:
            "> 240 mm²"
        };

      }


      return {
        metric:
          formatNumber(
            result.size,
            result.size % 1 === 0
              ? 0
              : 1
          ) +
          " mm²",

        awg:
          result.awg
      };

    }


    function hardwareDisplay(
      required,
      standardSizes
    ) {

      var size =
        nextStandardSize(
          required,
          standardSizes
        );


      if (size === null) {

        return t(
          "data-t-engineering-required",
          "Engineering required"
        );

      }


      return (
        "≥ " +
        formatNumber(
          size,
          0
        ) +
        " A"
      );

    }


    function calculate() {

      var singleVoltage =
        numberValue(
          battVoltage,
          12
        );


      var singleAh =
        numberValue(
          battAh,
          100
        );


      var selectedCRate =
        numberValue(
          cRate,
          0.5
        );


      var series =
        integerValue(
          seriesCount,
          1
        );


      var parallel =
        integerValue(
          parallelCount,
          1
        );


      var mainLength =
        numberValue(
          mainCableLength,
          2
        );


      var interconnectLength =
        numberValue(
          jumperLength,
          0.3
        );


      var dropPercent =
        numberValue(
          voltageDrop,
          3
        );


      /*
       * BATTERY BANK
       */

      var totalBatteries =
        series *
        parallel;


      var systemVoltage =
        singleVoltage *
        series;


      var totalAh =
        singleAh *
        parallel;


      var totalKwh =
        (
          systemVoltage *
          totalAh
        ) /
        1000;


      /*
       * Maximum continuous current according
       * to the entered manufacturer C-rate.
       */

      var stringCurrent =
        singleAh *
        selectedCRate;


      var totalCurrent =
        stringCurrent *
        parallel;


      var maxKw =
        (
          systemVoltage *
          totalCurrent
        ) /
        1000;


      /*
       * CONFIGURATION DISPLAY
       */

      setText(
        "cRateDisplay",
        formatNumber(
          selectedCRate,
          1
        ) +
        " C"
      );


      setText(
        "voltageDropDisplay",
        formatNumber(
          dropPercent,
          1
        ).replace(
          /[.,]0$/,
          ""
        ) +
        " %"
      );


      setText(
        "configDisplay",
        series +
        "S" +
        parallel +
        "P"
      );


      setText(
        "totalBatteriesDisplay",
        t(
          "data-t-batteries-total",
          "__COUNT__ batteries total"
        ).replace(
          "__COUNT__",
          totalBatteries
        )
      );


      setText(
        "sysVoltageDisplay",
        formatNumber(
          systemVoltage,
          systemVoltage % 1 === 0
            ? 0
            : 1
        ) +
        " V"
      );


      setText(
        "totalAhDisplay",
        formatNumber(
          totalAh,
          0
        ) +
        " Ah"
      );


      setText(
        "totalKwhDisplay",
        t(
          "data-t-energy",
          "__VALUE__ kWh energy"
        ).replace(
          "__VALUE__",
          formatNumber(
            totalKwh,
            2
          )
        )
      );


      setText(
        "stringAmpsDisplay",
        formatNumber(
          stringCurrent,
          0
        ) +
        " A"
      );


      setText(
        "maxAmpsDisplay",
        formatNumber(
          totalCurrent,
          0
        ) +
        " A"
      );


      setText(
        "maxKwDisplay",
        t(
          "data-t-motor-output",
          "__VALUE__ kW theoretical output"
        ).replace(
          "__VALUE__",
          formatNumber(
            maxKw,
            2
          )
        )
      );


      /*
       * CABLES
       *
       * Main cable:
       * battery/busbar to load and return,
       * so two conductor lengths.
       */

      var mainCable =
        calculateCable(
          totalCurrent,
          systemVoltage,
          mainLength,
          2,
          dropPercent
        );


      /*
       * Series jumper:
       * one physical jumper carries the
       * complete current of one series string.
       */

      var seriesJumper =
        series > 1
          ? calculateCable(
              stringCurrent,
              systemVoltage,
              interconnectLength,
              1,
              dropPercent
            )
          : null;


      /*
       * Parallel branch:
       * each string carries its own string current.
       * Positive + negative branch leads are counted.
       */

      var parallelCable =
        parallel > 1
          ? calculateCable(
              stringCurrent,
              systemVoltage,
              interconnectLength,
              2,
              dropPercent
            )
          : null;


      var mainDisplay =
        cableDisplay(
          mainCable
        );


      setText(
        "mainCableDisplay",
        mainDisplay.metric
      );


      setText(
        "mainAwgDisplay",
        mainDisplay.awg
      );


      if (series > 1) {

        var jumperDisplay =
          cableDisplay(
            seriesJumper
          );


        setText(
          "jumperCableDisplay",
          jumperDisplay.metric
        );


        setText(
          "jumperAwgDisplay",
          jumperDisplay.awg
        );


        var seriesJumperQuantity =
          (
            series - 1
          ) *
          parallel;


        setText(
          "jumperQuantityDisplay",
          t(
            "data-t-cables",
            "__COUNT__ cables"
          ).replace(
            "__COUNT__",
            seriesJumperQuantity
          )
        );

      } else {

        setText(
          "jumperCableDisplay",
          t(
            "data-t-not-required",
            "Not required"
          )
        );

        setText(
          "jumperAwgDisplay",
          "—"
        );

        setText(
          "jumperQuantityDisplay",
          "—"
        );

      }


      if (parallel > 1) {

        var branchDisplay =
          cableDisplay(
            parallelCable
          );


        setText(
          "parallelCableDisplay",
          branchDisplay.metric
        );


        setText(
          "parallelAwgDisplay",
          branchDisplay.awg
        );


        /*
         * Positive and negative lead
         * for every parallel string.
         */

        var branchCableQuantity =
          parallel *
          2;


        setText(
          "parallelQuantityDisplay",
          t(
            "data-t-cables",
            "__COUNT__ cables"
          ).replace(
            "__COUNT__",
            branchCableQuantity
          )
        );

      } else {

        setText(
          "parallelCableDisplay",
          t(
            "data-t-not-required",
            "Not required"
          )
        );

        setText(
          "parallelAwgDisplay",
          "—"
        );

        setText(
          "parallelQuantityDisplay",
          "—"
        );

      }


      /*
       * HARDWARE
       *
       * 1.25x is used here as a preliminary
       * planning target, NOT as automatic
       * protection compliance.
       */

      var hardwareTarget =
        totalCurrent *
        1.25;


      setText(
        "fuseDisplay",
        hardwareDisplay(
          hardwareTarget,
          BREAKER_SIZES
        )
      );


      setText(
        "switchDisplay",
        hardwareDisplay(
          hardwareTarget,
          SWITCH_SIZES
        )
      );


      setText(
        "busbarDisplay",
        hardwareDisplay(
          hardwareTarget,
          BUSBAR_SIZES
        )
      );


      setText(
        "shuntDisplay",
        hardwareDisplay(
          hardwareTarget,
          SHUNT_SIZES
        )
      );


      if (
        mainCable &&
        mainCable.size !== null
      ) {

        setText(
          "connectorDisplay",
          t(
            "data-t-cable-lugs",
            "Lugs for __SIZE__ mm² cable"
          ).replace(
            "__SIZE__",
            formatNumber(
              mainCable.size,
              mainCable.size % 1 === 0
                ? 0
                : 1
            )
          )
        );

      } else {

        setText(
          "connectorDisplay",
          t(
            "data-t-engineering-required",
            "Engineering required"
          )
        );

      }


      setText(
        "splitterDisplay",
        t(
          "data-t-optional",
          "Optional"
        )
      );


      /*
       * WARNINGS
       */

      var highCurrentBanner =
        root.querySelector(
          "#highCurrentBanner"
        );


      if (highCurrentBanner) {

        highCurrentBanner.hidden =
          totalCurrent <= 300;

      }


      var cableEngineeringRequired =
        (
          mainCable &&
          mainCable.size === null
        ) ||
        (
          seriesJumper &&
          seriesJumper.size === null
        ) ||
        (
          parallelCable &&
          parallelCable.size === null
        ) ||
        totalCurrent > 600;


      var engineeringBanner =
        root.querySelector(
          "#engineeringBanner"
        );


      if (engineeringBanner) {

        engineeringBanner.hidden =
          !cableEngineeringRequired;

      }

    }


    [
      battVoltage,
      battAh,
      cRate,
      seriesCount,
      parallelCount,
      mainCableLength,
      jumperLength,
      voltageDrop
    ].forEach(
      function (input) {

        input.addEventListener(
          "input",
          calculate
        );

        input.addEventListener(
          "change",
          calculate
        );

      }
    );


    calculate();

  }


  function init(root) {

    var calculators =
      root.querySelectorAll
        ? root.querySelectorAll(
            "[data-battery-calculator]"
          )
        : [];


    calculators.forEach(
      function (calculator) {

        initCalculator(
          calculator
        );

      }
    );

  }


  if (
    document.readyState ===
    "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      function () {

        init(document);

      }
    );

  } else {

    init(document);

  }


  document.addEventListener(
    "shopify:section:load",
    function (event) {

      init(
        event.target
      );

    }
  );

})();